<template>
	<div>
		<section class="heading">
			<h1 class="title">{{ title }}</h1>
			<button @click="$router.back()" class="btn btn-link btn-lg btn-cancel" :disabled="isLoading">
				Back
			</button>
		</section>
		<form @submit="e => { e.preventDefault(); onSubmit(fields); }">
			<div class="row">
				<div class="col-sm-12">
					<div class="box box-primary">
						<div class="box-body">
							<div class="row">
								<div class="col-xs-12 col-sm-8">
									<div class="row">
										<div class="col-xs-12 col-sm-6">
											<input-wrapper id="invoice_id" label="Invoice No">
												<v-select 
													name="invoice" 
													placeholder="Select Invoice"
													@input="onInvoiceChange"
													v-model="fields.invoice_id"
													:options="invoices"
													:disabled="editForm">
												</v-select>
											</input-wrapper>
										</div>
										<div class="col-xs-12 col-sm-6">
											<input-wrapper id="number" label="Number" :error="errors.number">
												<input v-model="fields.number" id="number" type="text" class="form-control" :disabled="editForm" required>
											</input-wrapper>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-12 col-sm-6">
											<input-wrapper id="date" label="Date">
												<input v-model="fields.date" id="date" type="date" class="form-control" :disabled="isLoading" required>
											</input-wrapper>
										</div>
										<div class="col-xs-12 col-sm-6">
											<input-wrapper id="amount" label="Amount" :error="errors.amount">
												<money v-model="fields.amount" v-bind="money" class="form-control" :disabled="isLoading" required />
											</input-wrapper>
										</div>
									</div>
								</div>
								<div class="col-xs-12 col-sm-4">
									<input-wrapper id="note" label="Note" :error="errors.note">
										<textarea 
											id="note" 
											rows="5" 
											class="form-control"
											v-model="fields.note"
											:disabled="isLoading" />
									</input-wrapper>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-12 text-right">
					<button class="btn btn-primary btn-lg" :disabled="isLoading">
						<i class="fa fa-circle-o-notch fa-spin" v-show="isLoading"></i>
						{{ submitTxt }}
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { Money } from 'v-money';
import { moneyTemplate, formatPrice } from '../../helpers';
import InputWrapper from "../InputWrapper.vue";
import AutoComplete from '../AutoComplete.vue';
import AddButton from '../AddButton.vue';
import DeleteButton from '../DeleteButton.vue';
import PaymentTerm from '../settings/PaymentTerm.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
	components: { InputWrapper, Money, AutoComplete, AddButton, DeleteButton, vSelect, PaymentTerm },
	props: {
		title: {
			type: String,
			required: true,
		},
		submitTxt: {
			type: String,
			required: true,
		},
		onSubmit: {
			type: Function,
			required: true,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		invoices: {
			type: Array,
			required: true
		},
		fields: {
			type: Object,
			required: true,
		},
		getInvoiceById: {
			type: Function,
			required: false,
		},
		editForm: {
			type: Boolean,
			default: false,
			required: false,
		},
		errors: {
			type: Object,
			required: true,
		},
		defaultFormType: {
			type: String,
			default: "create",
			validator: (val) => ["create", "edit"].includes(val)
		}
	},
	data() {
		return {
			money: moneyTemplate(),
		}
	},
	methods: {
		formatPrice,
		onInvoiceChange: function (event) {
			this.fields.invoice_id = event;
			if (event) {
				this.getInvoiceById(event.id);
			}
		},
	},
}
</script>